import { isVariableInLS } from '@/shared/lib/isVariableInLS';

export const IS_MIXPANEL_DEBUGGER_ENABLED = isVariableInLS('enableMixpanelDebugger');
// Read once before SDK initialization; changing this flag requires a page reload.
export const IS_MIXPANEL_CONSOLE_ONLY = isVariableInLS('enableMixpanelConsoleOnly');
